// extracted by mini-css-extract-plugin
export default {"divError":"ErrorBoundary_divError__xvsVq","logo":"ErrorBoundary_logo__6ttOl"};